import { PaletteOptions } from '@mui/material/styles';

export const MuiTypography = (palette: PaletteOptions) => ({
  styleOverrides: {
    root: {
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      variants: [
        {
          props: { variant: 'h1' },
          style: {
            fontSize: '3rem',
            fontWeight: '800',
            color: palette.text?.primary,
            letterSpacing: '0.02em',
          },
        },
        {
          props: { variant: 'h2' },
          style: {
            fontSize: '1.5rem',
            fontWeight: '600',
            color: palette.text?.primary,
            letterSpacing: '0.015em',
          },
        },
        {
          props: { variant: 'h3' },
          style: {
            fontSize: '1.25rem',
            fontWeight: '600',
            color: palette.text?.primary,
            letterSpacing: '0.01em',
          },
        },
        {
          props: { variant: 'h4' },
          style: {
            fontSize: '1rem',
            fontWeight: '900',
            color: palette.text?.primary,
            letterSpacing: '0.06em',
          },
        },
        {
          props: { variant: 'h5' },
          style: {
            fontSize: '0.75rem',
            fontWeight: '600',
            color: palette.text?.primary,
            letterSpacing: '0.04em',
          },
        },
        {
          props: { variant: 'h6' },
          style: {
            fontSize: '0.67rem',
            fontWeight: '600',
            color: palette.text?.primary,
            letterSpacing: '0.03em',
          },
        },
        {
          props: { variant: 'body1' },
          style: {
            fontSize: '1rem',
            fontWeight: '400',
            color: palette.text?.primary,
          },
        },
        {
          props: { variant: 'body2' },
          style: {
            fontSize: '0.875rem',
            fontWeight: '400',
            color: palette.text?.primary,
          },
        },
        {
          props: { variant: 'caption' },
          style: {
            fontSize: '0.75rem',
            fontWeight: '400',
            color: palette.text?.primary,
          },
        },
      ],
    },
  },
});
